export const EVENTS_PER_PAGE_DEFAULT = 18;
//# sourceMappingURL=constants.js.map